import { render } from "./GnbArea.vue?vue&type=template&id=27c5fb50"
import script from "./GnbArea.vue?vue&type=script&lang=js"
export * from "./GnbArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__